<template>
  <div class="headnav-wrapper">
    <nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary"
      itemtype="https://schema.org/SiteNavigationElement" itemscope>
      <div class="inside-navigation">
      <div class="navigation-branding">
        <div class="site-logo">
          <a href="/" title="GBWhatsApp" rel="home">
            <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/1.webp" title="GBWhatsApp">
          </a>
        </div>
        <div class="main-title" itemprop="headline">
          <a id="webName" href="/" rel="home">
            {{ $siteName }}
          </a>
        </div>
      </div>
      <!-- mobile的点击菜单 -->
      <div id="menu-primary-menu" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
        <div id="homeLink" class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/">GB WhatsApp</a>
        </div>
        <div class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/download/" class="download-btn">Download</a>
        </div>
        <div class="menu-item menu-item-type-post_type menu-item-object-post menu-item-33">
          <a href="/blog/">Blog</a>
        </div>
        <div v-for="group in navDropdowns" :key="'m-' + group.id" class="menu-item nav-dropdown-mobile">
          <div class="nav-dropdown-mobile__row">
            <a :href="group.href" class="nav-dropdown-mobile__main">{{ group.label }}</a>
            <button type="button" class="nav-dropdown-mobile__expand" :aria-expanded="mobileOpenDropdown === group.id"
              aria-label="Toggle submenu" @click.stop="toggleMobileDropdown(group.id)">
              <span class="nav-dropdown-mobile__caret" :class="{ open: mobileOpenDropdown === group.id }">▼</span>
            </button>
          </div>
          <div v-show="mobileOpenDropdown === group.id" class="nav-dropdown-mobile__sub">
            <a v-for="child in group.children" :key="child.href" :href="child.href">{{ child.label }}</a>
          </div>
        </div>
      </div>

      <div id="primary-menu" class="main-nav">
        <!-- mobile -->
        <div class="mobile-menu" v-if="$global.isMobileDevice()">
          <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
            <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
            <img src="@/assets/xmark-black.svg" alt="close button" v-else>
          </div>
        </div>
        <!-- pc -->
        <div v-else id="menu-primary-menu" class="nav-pc-row">
          <div id="homeLink" class="">
            <a href="/">GB WhatsApp</a>
          </div>
          <div class="">
            <a href="/download/" class="download-btn">Download</a>
          </div>
          <div class="">
            <a href="/blog/">Blog</a>
          </div>
          <div v-for="group in navDropdowns" :key="'d-' + group.id" class="nav-dropdown">
            <a :href="group.href" class="nav-dropdown__trigger">{{ group.label }} <span class="nav-dropdown__arrow">▾</span></a>
            <div class="nav-dropdown__panel" role="menu">
              <a v-for="child in group.children" :key="child.href" :href="child.href" class="nav-dropdown__link" role="menuitem">{{ child.label }}</a>
            </div>
          </div>
        </div>
      </div>
      </div>
    </nav>

    <div class="breadcrumbs" v-if="showBreadcrumbs && breadcrumbsItems.length">
      <a :href="breadcrumbsItems[0].href" class="breadcrumbs__home">{{ breadcrumbsItems[0].label }}</a>
      <span v-for="item in breadcrumbsItems.slice(1)" :key="item.href" class="breadcrumbs__item">
        <span class="breadcrumbs__sep">/</span>
        <a v-if="!item.current" :href="item.href">{{ item.label }}</a>
        <span v-else class="breadcrumbs__current">{{ item.label }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
    page: {
      type: String,
      required: true,
    },
    gotodownload: {
      type: Function,
    },
    apk: {
      type: Object,
    },
    showBreadcrumbs: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      navDropdowns: [
        {
          id: 'features',
          label: 'Features Hub',
          href: '/features/',
          children: [
            { label: 'Custom Themes', href: '/features/custom-themes/' },
            { label: 'Privacy Control', href: '/features/privacy-control/' },
            { label: 'Media Sharing', href: '/features/media-sharing/' },
            { label: 'Account Management', href: '/features/account-management/' },
          ],
        },
        {
          id: 'use-cases',
          label: 'Use Cases',
          href: '/use-cases/',
          children: [
            { label: 'Small Business', href: '/use-cases/small-business/' },
            { label: 'Social Influencers', href: '/use-cases/social-influencers/' },
            { label: 'Gaming Communities', href: '/use-cases/gaming-communities/' },
            { label: 'International Users', href: '/use-cases/international-users/' },
          ],
        },
        {
          id: 'mods',
          label: 'Mods',
          href: '/mods/',
          children: [
            { label: 'YoWhatsApp', href: '/mods/yowhatsapp/' },
            { label: 'FMWhatsApp', href: '/mods/fmwhatsapp/' },
            { label: 'Blue WhatsApp', href: '/mods/blue-whatsapp/' },
            { label: 'Red WhatsApp', href: '/mods/red-whatsapp/' },
            { label: 'WhatsApp Plus', href: '/mods/whatsapp-plus/' },
          ],
        },
      ],
      mobileOpenDropdown: null,
      isHovered: false,
      isMenuClicked: false,
      isModClicked: false,
      isSearchClicked: false,
      lang: [{
        lang: 'en',
        val: '🇺🇸 English'
      },
      {
        lang: 'ar',
        val: '🇦🇪 اَلْعَرَبِيَّةُ'
      },
      {
        lang: 'id',
        val: '🇮🇩 Bahasa Indonesia'
      },
      {
        lang: 'pt',
        val: '🇵🇹 Português'
      },
      {
        lang: 'es',
        val: '🇪🇸 Español'
      },
      {
        lang: 'hi',
        val: '🇮🇳 हिंदी'
      },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          mod: 'WhatsApp Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
          mod: 'مودات واتس اب',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
          mod: 'Mod WhatsApp',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
          mod: 'Mods do WhatsApp',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
          mod: 'Mods de WhatsApp',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
          mod: 'व्हाट्सएप मोड्स',
        },
      },
    }
  },
  computed: {
    breadcrumbsItems() {
      const path = this.$route?.path || '/'
      if (path === '/') {
        return []
      }

      const parts = path.split('/').filter(Boolean)

      const labelMap = {
        download: 'Download',
        blog: 'Blogs',
        mods: 'Mods',
        features: 'Features',
        'use-cases': 'Use Cases',
        'privacy-control': 'Privacy Control',
        'media-sharing': 'Media Sharing',
        'account-management': 'Account Management',
        'small-business': 'Small Business',
        'social-influencers': 'Social Influencers',
        'gaming-communities': 'Gaming Communities',
        'international-users': 'International Users',
        'yowhatsapp': 'YO WhatsApp',
        'fmwhatsapp': 'FM WhatsApp',
        'blue-whatsapp': 'Blue WhatsApp',
        'red-whatsapp': 'Red WhatsApp',
        'whatsapp-plus': 'WhatsApp Plus',
        'resolving-gbwhatsapp-installation-issues': 'Installation Issues',
        'unread-messages-in-gbwhatsapp': 'Unread Messages',
        'how-to-read-messages-in-gbwhatsapp': 'Read Deleted Messages',
        'how-to-schedule-messages-in-gbwhatsapp': 'Schedule Messages',
        'gbwhatsapp': 'GB WhatsApp',
      }

      const normalizeWord = (w) => {
        const lw = String(w).toLowerCase()
        if (lw === 'gb') return 'GB'
        if (lw === 'whatsapp') return 'WhatsApp'
        if (lw === 'yo') return 'YO'
        if (lw === 'fm') return 'FM'
        if (lw === 'blue') return 'Blue'
        if (lw === 'red') return 'Red'
        if (lw === 'plus') return 'Plus'
        if (/^\d+$/.test(lw)) return lw
        return lw.charAt(0).toUpperCase() + lw.slice(1)
      }

      const segmentLabel = (seg) => {
        if (labelMap[seg]) return labelMap[seg]
        return String(seg)
          .split('-')
          .filter(Boolean)
          .map(normalizeWord)
          .join(' ')
      }

      const items = [
        { label: 'Home', href: '/', current: false },
      ]

      let accum = []
      parts.forEach((part, idx) => {
        accum.push(part)
        const href = `/${accum.join('/')}/`
        items.push({
          label: segmentLabel(part),
          href,
          current: idx === parts.length - 1,
        })
      })

      return items
    },
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    },
    isMenuClicked(open) {
      if (!open) this.mobileOpenDropdown = null;
    },
  },
  methods: {
    toggleMobileDropdown(id) {
      this.mobileOpenDropdown = this.mobileOpenDropdown === id ? null : id;
    },
    changeLanguage(lang) {
      console.log("changelang: ", lang);
      console.log("page: ", this.page);
      this.$router.push({
        name: `${this.selectedLanguage}-${this.page}`
      });
    },
    download() {
      if (typeof this.gotodownload === "function") {
        this.gotodownload();
      } else {
        console.error("gotodownload is not a function");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.nav-dropdown__link{
  color: #121212 !important;
}

.breadcrumbs {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto 12px;
  padding: 20px 20px 0;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #666;

  a {
    color: #667eea;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  &__sep {
    color: #999;
    margin: 0 6px;
  }

  &__current {
    color: #333;
    font-weight: 600;
  }
}

#site-navigation {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .inside-navigation {
    width: 80%;
    margin: 0 auto;
    z-index: 9999;
    position: relative;
  }
}

#backtop {
  width: 30px;
  height: 30px;
  position: fixed;
  right: 50px;
  bottom: 100px;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 50%;
  box-sizing: content-box;

  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.main-nav {
  .menu {
    list-style-type: none !important;
    margin: 0 !important;

    li {
      a {
        font-weight: 500 !important;
      }
    }
  }
}

.nav-pc-row {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  row-gap: 10px;

  a {
    color: #fff;
    text-decoration: none;
    font-weight: 400;
  }

  #homeLink a {
    font-weight: 400;
  }
}

.nav-dropdown {
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    height: 10px;
    z-index: 10019;
  }

  &__trigger {
    color: #fff;
    text-decoration: none;
    font-weight: 400;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  &__arrow {
    font-size: 10px;
    opacity: 0.75;
  }

  &__panel {
    position: absolute;
    left: 0;
    top: calc(100% + 6px);
    min-width: 220px;
    padding: 8px 0;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    opacity: 0;
    visibility: hidden;
    transform: translateY(-4px);
    transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s;
    z-index: 10020;
  }

  &__link {
    display: block;
    padding: 10px 16px;
    color: #121212;
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;

    &:hover {
      background: #f0f0f0;
    }
  }

  &:hover .nav-dropdown__panel,
  &:focus-within .nav-dropdown__panel {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.nav-dropdown-mobile {
  &__row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 14px 0;
    background: #fff;
  }

  &__main {
    flex: 1;
    text-align: center;
    font-size: 15px;
    color: #121212;
    font-weight: 600;
  }

  &__expand {
    flex: 0 0 40px;
    border: none;
    background: transparent;
    padding: 8px;
    cursor: pointer;
    line-height: 1;
    color: #121212;
  }

  &__caret {
    font-size: 10px;
    color: #121212;
    transition: transform 0.2s;

    &.open {
      transform: rotate(-180deg);
    }
  }

  &__sub {
    display: flex;
    flex-direction: column;
    background: #fafafa;

    a {
      padding: 10px 16px 10px 28px;
      font-size: 14px;
      color: #333;
      text-align: left;
      border-top: 1px solid #eee;
    }
  }
}

@media screen and (max-width: 768px) {

  .inside-navigation {

    .mobile-menu-page {
      position: absolute;
      top: 100%;
      width: 100%;
      z-index: 1001;
      margin: 0 !important;

      .menu-item {
        padding: 14px 0;
        margin-bottom: 0 !important;
        background: #fff;

        a {
          font-size: 15px;
          text-align: center;
          color: #121212;
          display: block;
        }
      }
    }
  }

  .main-nav {
    flex: 1;
    margin-right: 10px;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
      position: relative;

      .language-selector {
        width: 60%;

        #language-select {
          width: 100%;
        }
      }

      .menu-toggle {
        display: block;
        display: flex;
        justify-content: center;
        padding: 12px 12px;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .search-toggle {
        display: block;
        padding: 12px 12px;
        display: flex;
        justify-content: center;
        margin-bottom: 0;

        img {
          width: 23px;
          height: 23px;
        }
      }
    }
  }
}
</style>
